import { render, staticRenderFns } from "./AttachmentCreate.vue?vue&type=template&id=24a74aa1"
import script from "./AttachmentCreate.vue?vue&type=script&lang=js"
export * from "./AttachmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports